import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeSort, changeSortDirection } from "../../redux/actions";
import { type RootState } from "~/app/store";
import { SortingPicker } from "~/features/search/components/common/SortingPicker";
import { type SortDirection } from "~/features/search/models/models";

interface Props {
  className?: string;
}

export const ReduxSortingPicker = (props: Props) => {
  const options = useSelector(selectOptions);
  const selectedCode = useSelector(selectSelectedCode);
  const selectedDirection = useSelector(selectSelectedDirection);

  const dispatch = useDispatch();
  const callbacks = useMemo(() => {
    return {
      onAscDesc: (newVal: SortDirection) => dispatch(changeSortDirection(newVal)),
      onSelect: (newSortCode: string = "") => {
        const direction = options.find((item) => item.code === newSortCode)?.sortingDirection;
        dispatch(changeSort(newSortCode, direction));
      },
    };
  }, [dispatch]);

  const data = {
    options,
    selectedCode,
    selectedDirection,
  };

  return <SortingPicker {...props} {...data} {...callbacks} label={false} />;
};

const selectOptions = (state: RootState) => state.srp.sort.availableSorts;
const selectSelectedCode = (state: RootState) => state.srp.sort.selectedCode;
const selectSelectedDirection = (state: RootState) => state.srp.sort.selectedDirection;

export default ReduxSortingPicker;
